// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"UserManagement_loadingOverlay__eXOAR"};